module.exports = __webpack_public_path__ + "static/media/hex-background.cbc22e71.jpg";